import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Button, Form, FormControl } from "react-bootstrap";
import SimpleReactValidator from "simple-react-validator";
import Spinner from "views/lib/components/Spinner";

import {
    fetchCities,
    fetchCitiesById,
    createCity,
    updateCity
} from "actions/locations/actions";

class CityModal extends React.Component {
    constructor(props) {
        super(props);

        this.save = this.save.bind(this);
        this.handleChangeInput = this.handleChangeInput.bind(this);
        this.handleChangeBool = this.handleChangeBool.bind(this);

        this.state = {
            name: "",
            travelCharge: 0,
            inactive: false,
            isTravelRegion: false,
            provinceId: this.props.currentProvince.id
        };

        this.validator = new SimpleReactValidator({
            locale: "en",
            element: message => <div className="text-danger">{message}</div>
        });
    }

    componentDidMount () {
        if (this.props.cityId) {
            this.props.fetchCitiesById(this.props.cityId);
        }
    }

    componentWillReceiveProps (nextProps) {
        const { currentCity } = nextProps;
        this.setState(currentCity);
    }

    save = () => {
        if (this.validator.allValid()) {
            const callback = () => {
                this.props.fetchCities(this.state.provinceId);
                this.props.onCancel();
            };

            const requestData = {
                name: this.state.name,
                inactive: this.state.inactive,
                provinceId: this.state.provinceId,
                isTravelRegion: this.state.isTravelRegion,
                travelCharge: parseFloat(this.state.travelCharge)
            };
            if (this.props.cityId) {
                this.props.updateCity(this.props.cityId, requestData, callback);
            } else {
                this.props.createCity(requestData, callback);
            }
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    handleChangeInput = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleChangeBool = (name) => {
        this.setState({ [name]: !this.state[name] });
    };

    render () {
        const {
            name,
            travelCharge,
            inactive,
            isTravelRegion
        } = this.state;

        const { currentCountry, currentProvince } = this.props;

        return (
            <form autoComplete="off" role="presentation" className="position-relative container">
                {!this.props.loading || <Spinner />}

                <h4 className="mb-0">Country: {currentCountry.fullName}</h4>
                <h4 className="">Province: {currentProvince.fullName}</h4>

                <Form.Group controlId="name">
                    <Form.Label>City Name</Form.Label>
                    <FormControl
                        type="text"
                        name="name"
                        onChange={this.handleChangeInput}
                        value={name}
                        required={true}
                        isValid={false}
                    />
                    {this.validator.message("name", name, "required")}
                </Form.Group>

                <Form.Group controlId="travelCharge">
                    <Form.Label>Travel Charge</Form.Label>
                    <FormControl
                        type="number"
                        name="travelCharge"
                        onChange={this.handleChangeInput}
                        value={travelCharge}
                        required={true}
                        isValid={false}
                    />
                    {this.validator.message("travelCharge", travelCharge, "required|numeric")}
                </Form.Group>

                <div className="row">
                    <div className="col-12 col-sm-3">
                        <Form.Group>
                            <Form.Check
                                name="inactive"
                                onChange={() => this.handleChangeBool("inactive")}
                                checked={inactive}
                                label="Inactive"
                                id="inactive"
                            />
                        </Form.Group>
                    </div>
                    <div className="col-12 col-sm-3">
                        <Form.Group>
                            <Form.Check
                                name="isTravelRegion"
                                onChange={() => this.handleChangeBool("isTravelRegion")}
                                checked={isTravelRegion}
                                label="Is Travel Region"
                                id="isTravelRegion"
                            />
                        </Form.Group>
                    </div>
                </div>

                <div className="text-right">
                    <Button className="ml-2" variant="outline-primary" onClick={() => this.props.onCancel()}>
                        Cancel
                    </Button>
                    <Button className="ml-2" variant="success" onClick={this.save}>
                        {this.props.cityId ? "Update" : "Create"}
                    </Button>
                </div>

            </form>
        );
    }
}

CityModal.propTypes = {
    cityId: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]).isRequired,
    onCancel: PropTypes.func.isRequired,
    currentCity: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    currentCountry: state.locations.currentCountry,
    currentProvince: state.locations.currentProvince,
    currentCity: state.locations.currentCity,
});

const mapStateToDispatch = dispatch => ({
    fetchCities: bindActionCreators(fetchCities, dispatch),
    fetchCitiesById: bindActionCreators(fetchCitiesById, dispatch),
    createCity: bindActionCreators(createCity, dispatch),
    updateCity: bindActionCreators(updateCity, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(CityModal);



// WEBPACK FOOTER //
// ./src/views/pages/locations/city-modal.js